import { ChartLine, CircleDollarSign, Gauge, ListOrdered, Users } from 'lucide-react';
import { SummaryPage } from './routes/summary.js';
import { CampaignsPage } from './routes/campaigns.js';
import { PortraitPage } from './routes/portrait.js';
import { TrendPage } from './routes/trend.js';
/**
 * Раздел «Окупаемость» пространства «Реклама» (спека 2026-10-21): окупится ли
 * реклама — прогноз на 120 дней после вычетов из старого отчёта auto-ads через
 * admin-api `/api/ads/payback/*`.
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`,
 * `ui-forms`), `admin-client-core` и `admin-contracts` (ESLint allowlist).
 * Своего PermsProvider нет — раздел только читает; права проверяют навигация
 * (`ads.read`) и admin-api.
 */
export const adsPaybackModule = {
    id: 'payback',
    label: 'Окупаемость',
    icon: CircleDollarSign,
    permission: 'ads.read',
    workspace: 'ads',
    order: 20,
    description: 'Окупится ли реклама: прогноз на 120 дней после вычетов, кампании, покупатели, динамика.',
    showInNav: true,
    sectionsPlacement: 'sidebar',
    // Шапку экранов рисует навбар: заголовок — крошка, период и кабинеты —
    // тулбар страницы в навбаре, описание — ⓘ у крошек.
    routeChrome: 'shell',
    sections: [
        { path: '/', label: 'Сводка', icon: Gauge },
        { path: '/campaigns', label: 'Кампании', icon: ListOrdered },
        { path: '/portrait', label: 'Кто покупает', icon: Users },
        { path: '/trend', label: 'Динамика', icon: ChartLine },
    ],
    routes: [
        { path: '/', component: SummaryPage },
        { path: '/campaigns', component: CampaignsPage },
        { path: '/portrait', component: PortraitPage },
        { path: '/trend', component: TrendPage },
    ],
};
export { setAdsPaybackApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map